import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { CitaService } from "src/app/core/services/cita.service";
import { BucketsService } from "src/app/core/services/buckets.service";
import { CitasPagosService } from "src/app/core/services/citas-pagos.service";
import { environment } from "src/environments/environment";
import { SpanishDatePipe } from "./spanishDate.pipe";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-historial-citas",
  standalone: true,
  imports: [CommonModule, RouterModule, DatePipe, SpanishDatePipe],
  templateUrl: "./historial-citas.component.html",
  styleUrl: "../../app.component.scss",
})
export class HistorialCitasComponent implements OnInit {
  listadoCitas: any[] = [];
  currentUser: any;
  private BUCKET_FOTOS_ESPECIALISTAS = environment.bucketFotosEspecialistas;
  isLoading = true;

  constructor(
    private __citaService: CitaService,
    private __bucketService: BucketsService,
    private __citasPagosService: CitasPagosService,
  ) {}

  async ngOnInit(): Promise<void> {
    const currentUser = localStorage.getItem("currentPatient");
    if (currentUser) {
      this.currentUser = JSON.parse(currentUser);
      await this.getCitasHistorial(this.currentUser.userId);
    }
  }

  // OBTENER EL HISTORIAL DE CITAS DE UN PACIENTE
  async getCitasHistorial(idPaciente: string) {
    try {
      const listadoCitas: any = await this.__citaService.getDocumentsbyPaciente(
        idPaciente,
      );

      // Filtrar citas por estados de historial (terminadas, canceladas, etc.)
      const estadosHistorial = [
        "terminada",
        "cancelada",
        "reprogramada",
        "noasistio",
        "cerrada",
      ];
      const citasFiltradas = listadoCitas.filter((cita) =>
        estadosHistorial.includes(cita.idEstadoCita.$id),
      );

      console.log("Historial de Citas", citasFiltradas);

      if (citasFiltradas.length === 0) {
        this.listadoCitas = [];
        this.isLoading = false;
        return;
      }

      // Procesar citas para obtener información adicional
      const citasConInfoCompleta = await Promise.all(
        citasFiltradas.map(async (cita: any) => {
          try {
            if (cita.IdEstadoPago === "paquete") {
              const fotoUrl = await this.__bucketService.getBucket(
                this.BUCKET_FOTOS_ESPECIALISTAS,
                cita.idEspecialista.foto,
              );
              cita.pagoCita = "paquete";
              cita.idEspecialista.foto = fotoUrl; // ASIGNAR LA FOTO
              return cita;
            }

            const [pagoCita, fotoUrl] = await Promise.all([
              this.__citasPagosService.getDataByCita(cita.$id),
              this.__bucketService.getBucket(
                this.BUCKET_FOTOS_ESPECIALISTAS,
                cita.idEspecialista.foto,
              ),
            ]);

            cita.pagoCita = pagoCita[0];
            cita.idEspecialista.foto = fotoUrl; // ASIGNAR LA FOTO
            return cita;
          } catch (error) {
            console.error("Error procesando cita:", error);
            return cita;
          }
        }),
      );

      this.listadoCitas = citasConInfoCompleta;
    } catch (error) {
      console.error("Error obteniendo historial de citas:", error);
    } finally {
      this.isLoading = false;
    }
  }

  convertToLocal(date: string | Date): Date {
    const utcDate = new Date(date);
    const localDate = new Date(utcDate.getTime() - -5 * 60 * 60 * 1000); // UTC-5
    return localDate;
  }

  getBadgeClass(estado: string): string {
    const clases = {
      terminada: "badge bg-success",
      cancelada: "badge bg-danger",
      reprogramada: "badge bg-warning",
      no_asistio: "badge bg-secondary",
      default: "badge bg-info",
    };

    return clases[estado] || clases["default"];
  }
}
